import { AccountInfo } from "@azure/msal-browser";
import { useQuery } from "@tanstack/react-query";
import { userProfileService } from "../services/userProfileService";

/**
 * Hook React Query pour récupérer la photo de profil d'un utilisateur
 * Utilise le cache du service pour gérer les URLs blob et leur cleanup
 */
export const useUserPhoto = (account: AccountInfo) => {
  return useQuery({
    queryKey: ["user-photo", account.username],
    queryFn: () => userProfileService.getUserPhoto(account),
    staleTime: 1000 * 60 * 60, // 1h - photos changent rarement
    gcTime: 1000 * 60 * 60 * 24, // 24h
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
